const menuPhotographers = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
      <g fill="none" fill-rule="evenodd" transform="translate(1)">
        <g stroke="#F5F5F5" stroke-linejoin="round" transform="translate(0 .75)">
          <path stroke-linecap="round" d="M6.375,12.375 L6.375,12.77475 L2.18175,14.322 C1.098,14.709 0.375,15.75 0.375,16.875 L17.625,16.875 C17.625,15.75 16.9005,14.709 15.81675,14.32275 L11.625,12.77475 L11.625,9.79125"/>
          <path stroke-linecap="round" d="M4.98,2.6715 C5.7705,1.0725 7.224,0 8.88675,0 C11.39325,0 13.4265,2.439 13.4265,5.44725 C13.4265,7.7625 12.22275,9.74025 10.52625,10.5285"/>
          <path stroke-linecap="round" d="M13.34175,4.395 C12.099,4.54125 10.81125,4.8255 9.5805,2.67075 C9.39,3.036 9.04725,3.37425 8.62425,3.65325"/>
          <path d="M9.375,10.125 C9.375,10.53975 9.039,10.875 8.625,10.875 L1.125,10.875 C0.711,10.875 0.375,10.53975 0.375,10.125 L0.375,5.625 C0.375,5.21025 0.711,4.875 1.125,4.875 L4.125,4.875 C4.335,4.455 4.46325,4.125 4.9635,4.125 L6.6615,4.125 C7.16175,4.125 7.29,4.455 7.5,4.875 L8.625,4.875 C9.039,4.875 9.375,5.21025 9.375,5.625 L9.375,10.125 Z"/>
          <circle cx="5.625" cy="7.5" r="1.5"/>
          <rect width="1" height="1" x="1.5" y="4.125"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuPhotographers;
